import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Subscription, SubscriptionStatus } from "@appTypes/index";
import MobileSourceHelperText from "@components/Subscriptions/MobileSourceHelperText";
import { formatSubscriptionRenewalDateInfo } from "@utils/getSubscriptionDisplayInformation";

interface SubscriptionRenewalInfoProps {
  subscription: Subscription;
  status: SubscriptionStatus;
}

const SubscriptionRenewalInfo = ({ subscription, status }: SubscriptionRenewalInfoProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <Typography variant="body2" color="text.primary">
        {formatSubscriptionRenewalDateInfo(subscription, status, t)}
      </Typography>
      <MobileSourceHelperText source={subscription.source} />
    </div>
  );
};

export default SubscriptionRenewalInfo;
